/**
 * NewsItemView view component.
 * @module components/theme/View/NewsItemView
 */

import React from 'react';
import PropTypes from 'prop-types';
import { Container as SemanticContainer, Grid } from 'semantic-ui-react';
import { hasBlocksData, flattenHTMLToAppURL, BodyClass } from '@plone/volto/helpers';
import RenderBlocks from '@plone/volto/components/theme/View/RenderBlocks';
import config from '@plone/volto/registry';
import { FormattedDate } from '@plone/volto/components';
import { FormattedMessage, } from 'react-intl';
import { flattenToAppURL } from '@plone/volto/helpers';
import { Attachments, Sharing } from '../';

/**
 * NewsItemView view component class.
 * @function NewsItemView
 * @params {object} content Content object.
 * @returns {string} Markup of the component.
 */
const NewsItemView = ({ content }) => {
  const Image = config.getComponent({ name: 'Image' }).component;
  const Container =
    config.getComponent({ name: 'Container' }).component || SemanticContainer;

    return hasBlocksData(content) ? (
      <>
        <BodyClass className='noImageHeading' />
        <Container id="page-document" className="view-wrapper newsitem-view">
          <div className="d-flex align-items-center mb-4">
            {content?.review_state == 'published' ?
             (<time dateTime={content.effective} className='d-block fw-bold'>
              <FormattedDate date={content.effective} className=""
                format={{
                  day: "2-digit",
                  month: "2-digit",
                  year: "numeric",
                }}
              />
            </time>
            ) : ( <span>-</span> )}
            <div className="d-flex align-items-center border-1 border-start border-dark ms-3 ps-3">
              <span className='me-2 text-uppercase fs-sm'>
                <FormattedMessage
                  id="Share"
                  defaultMessage="Share"
                />
              </span>
              <Sharing id={content['@id']} title={content.title} url={flattenToAppURL(content['@id'])} />
            </div>

          </div>
          <Grid >
            <Grid.Row columns={12}>
              <Grid.Column 
                mobile={12} 
                tablet={content.preview_image ? 6 : 12}
                computer={content.preview_image ? 7 : 12}
                className='mb-5 mb-md-0' >
                <RenderBlocks content={content} />
              </Grid.Column>
              {content.preview_image && (
                <Grid.Column mobile={12} tablet={6} computer={5}>
                  <figure className="newsPage__img m-0" >
                    <Image
                      className="documentImage ui image"
                      alt=""
                      item={content}
                      imageField="preview_image"
                      responsive={true}
                      sizes="100vw"
                    />
                    {content.preview_caption && (
                      <figcaption className='newsPage__img__caption'>{content.preview_caption}</figcaption>
                    )}
                  </figure>
                </Grid.Column>
              )}
            </Grid.Row>
          </Grid>
          <Attachments {...content} />
          
        </Container>
      </>
  ) : (
    <>
      <BodyClass className='noImageHeading' />
      <Container className="view-wrapper">
        {content.title && (
          <h1 className="documentFirstHeading">
            {content.title}
            {content.subtitle && ` - ${content.subtitle}`}
          </h1>
        )}
        {content.description && (
          <p className="documentDescription">{content.description}</p>
        )}
        <time dateTime={content.effective} className='d-block mb-4 fw-bold'>
          <FormattedDate date={content.effective} className=""
            format={{
              day: "2-digit",
              month: "2-digit",
              year: "numeric",
            }}
          />
        </time>
        <Grid>
          <Grid.Row columns={12}>
            {content.text && (
              <Grid.Column mobile={12} tablet={6} computer={7} className='mb-5 mb-md-0'>
                <div
                  dangerouslySetInnerHTML={{
                    __html: flattenHTMLToAppURL(content.text.data),
                  }}
                />
              </Grid.Column>
            )}
            {content.image && (
              <Grid.Column mobile={12} tablet={6} computer={5}>
                <Image
                  className="documentImage ui right floated image"
                  alt={content.title}
                  title={content.title}
                  item={content}
                  imageField="image"
                  responsive={true}
                />
              </Grid.Column>
            )}
          </Grid.Row>
        </Grid>
      </Container>
    </>
  );
};

/**
 * Property types.
 * @property {Object} propTypes Property types.
 * @static
 */
NewsItemView.propTypes = {
  content: PropTypes.shape({
    title: PropTypes.string,
    description: PropTypes.string,
    text: PropTypes.shape({
      data: PropTypes.string,
    }),
  }).isRequired,
};

export default NewsItemView;
